import type {
  QuestionBooleanModelData,
  SurveyAnswerRecord,
  SurveyAnswerValue,
} from '@coorum-research/shared-common/types'
import type { SurveyModel } from 'survey-core'
import type { SelectBooleanOption } from '../../utils'
import type { SurveyElementFormHandler } from './survey-element-form'
import { ValidationErrorMessages } from '@coorum-research/shared-common/shared/survey/survey-validation'
import { generateBooleanSelectOption } from '../../utils'

export class SurveyElementFormHandlerBoolean implements SurveyElementFormHandler {
  readonly #elementJson: QuestionBooleanModelData
  #elementResultRecord: SurveyAnswerRecord | null

  constructor(
    elementJson: QuestionBooleanModelData,
    elementResultRecord: SurveyAnswerRecord | null,
  ) {
    this.#elementJson = elementJson
    this.#elementResultRecord = elementResultRecord
  }

  get elementJson(): QuestionBooleanModelData {
    return this.#elementJson
  }

  get surveyModel(): SurveyModel | null {
    return null
  }

  get data(): SurveyAnswerRecord {
    return this.#elementResultRecord || {}
  }

  getValue(): SurveyAnswerValue {
    return this.#elementResultRecord?.[this.#elementJson.name] === undefined ? '' : this.#elementResultRecord?.[this.#elementJson.name] as boolean
  }

  getComment(): string {
    return this.#elementResultRecord?.[`${this.#elementJson.name}-Comment`] as string || ''
  }

  getSelectOptions(): SelectBooleanOption[] {
    return generateBooleanSelectOption(this.#elementJson)
  }

  getSelectOptionValue(): SurveyAnswerValue {
    const originalValue = this.getValue()

    // falsy(empty value)なら、そのまま帰す
    if (!String(originalValue)) {
      return ''
    }

    // originalValue値が存在する場合
    // option.valueは true, false
    const matchedOptions = this.getSelectOptions().filter(option => option.value === Boolean(originalValue))
    if (matchedOptions.length > 0) {
      // 一致する値がある場合は、そのままoriginalValueを返す
      return Boolean(originalValue)
    }

    return '' // 一致する値がない場合は '' 「回答なし」と判定
  }

  setElementResultRecordValue(value: SurveyAnswerValue) {
    if (!this.#elementResultRecord) {
      this.#elementResultRecord = {}
    }

    this.#elementResultRecord[this.#elementJson.name] = Boolean(value)
  }

  setElementResultRecordComment(comment: string) {
    if (!this.#elementResultRecord) {
      this.#elementResultRecord = {}
    }

    this.#elementResultRecord[`${this.#elementJson.name}-Comment`] = comment || ''
  }

  validate(): {
    isValid: boolean
    errorMessage?: string
  } {
    const element = this.#elementJson
    const value = this.getValue()

    // 必須チェック
    if (element.isRequired && (value === null || value === undefined || value === '')) {
      return {
        isValid: false,
        errorMessage: ValidationErrorMessages.REQUIRED,
      }
    }

    return {
      isValid: true,
    }
  }
}
